import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface INameCategoryInput {
	changeNameOfCategory: (value: string) => void;
}

const NameCategoryInput: React.FC<INameCategoryInput> = ({ changeNameOfCategory }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCategoryName') }], [t]);

	return (
		<FormInput
			testId="NameCategoryInput"
			name="nameOfCategory"
			label="nameCategoryLabel"
			onChange={changeNameOfCategory}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
};

export default React.memo(NameCategoryInput);
